import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './MeusChamados.css'

const MeusChamados = () => {
    const [list, setList] = useState([])

    useEffect(() => {
        const url = `/api/suporte/meusChamadosJuridico`
        axios(url)
            .then(resp => {
                setList(resp.data)
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }, [])

    const arquiva = (id) => {
        const url = '/api/suporte/arquiva'
        axios.post(url, { id })
            .then(res => {
                alert(res.data)
                window.location = `/juridico/meusChamados`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-headphones iconeBuscaPed"></i>
                SUPORTE
            </div>
            <div className="labelMeusChamados">
                MEUS CHAMADOS
            </div>
            <div className="overFlow">
                <div className="meusChamadosHeader">
                    <div className="meusChamadosElementHeader">SITUAÇÃO</div>
                    <div className="meusChamadosElementHeader">NÚMERO</div>
                    <div className="meusChamadosElementHeader">MOTIVO</div>
                    <div className="meusChamadosElementHeader">DATA</div>
                    <div className="meusChamadosElementHeaderA">ABRIR/ARQUIVAR</div>
                </div>
                {RenderChamados()}
            </div>
        </React.Fragment>
    )

    function RenderChamados() {
        if (list.length > 0) {
            let tabela = []
            list.map(chamado => {
                if (!chamado.arquivado && chamado.resposta) {
                    tabela.push(
                        <div className="meusChamadosBody">
                            <div className="meusChamadosElementBody">RESPONDIDO</div>
                            <div className="meusChamadosElementBody">{chamado.numero}</div>
                            <div className="meusChamadosElementBody">{chamado.tipo}</div>
                            <div className="meusChamadosElementBody">{chamado.data}</div>
                            <div className="meusChamadosElementBodyI">
                                <a href={`/etica/chamado/${chamado._id}`}><i className="bi bi-envelope-open iChamado mr-2"></i></a>
                                <a onClick={e => arquiva(chamado._id)}><i className="bi bi-archive iChamado"></i></a>
                            </div>
                        </div>
                    )
                } else if (!chamado.arquivado && !chamado.resposta) {
                    tabela.push(
                        <div className="meusChamadosBody">
                            <div className="meusChamadosElementBody">EM ANÁLISE</div>
                            <div className="meusChamadosElementBody">{chamado.numero}</div>
                            <div className="meusChamadosElementBody">{chamado.tipo}</div>
                            <div className="meusChamadosElementBody">{chamado.data}</div>
                            <div className="meusChamadosElementBodyI">
                                <a href={`/etica/chamado/${chamado._id}`}><i className="bi bi-envelope-open iChamado"></i></a>
                                <a onClick={e => arquiva(chamado._id)}><i className="bi bi-archive iChamado"></i></a>
                            </div>
                        </div>
                    )
                }
            })
            return tabela
        }
    }
}

export default MeusChamados